"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Bookmark = _interopRequireDefault(require("./Bookmark.style"));

var Bookmark = function Bookmark(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["icon", "size", "isActive", "onClick"]);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    onClick();
  };

  return /*#__PURE__*/_react.default.createElement(_Bookmark.default, Object.assign({}, rest, {
    onClick: handleClick,
    isActive: isActive
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon,
    size: "28px"
  }));
};

Bookmark.propTypes = {
  icon: _propTypes.default.string,
  size: _propTypes.default.string,
  isActive: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired
};
Bookmark.defaultProps = {
  icon: 'Bookmark',
  size: '28px'
};
var _default = Bookmark;
exports.default = _default;